export default "__VITE_ASSET__FqY53mWS__"